(function () {
	// Hero background (#section1): the background photo with a field of slowly
	// drifting dots that connect with thin lines when they come close — the same
	// "particle network" look as innotecht.com.au. Replaces the old WebGL water
	// ripple. The cursor links to nearby dots (the old hover interaction).
	//
	// File name is kept (liquid-background) so the enqueue / script_loader_tag
	// wiring in functions.php is unchanged; it no longer needs three.js or a CDN.
	var CONFIG = {
		// Dot count is per 1920×1080 of hero area, then scaled to the real size.
		density: 100,
		minDots: 28,
		maxDots: 130,
		radius: 3, // dot radius (px)
		dotOpacity: 0.5,
		speed: 1, // px per 1/60s frame
		linkDistance: 150, // px — dots closer than this get a line
		linkOpacity: 0.5, // strongest line (fades to 0 at linkDistance)
		linkWidth: 1,
		mouseDistance: 180, // px — cursor links to dots inside this radius
		mouseOpacity: 0.85,
		color: "255,255,255",
	};

	function initHeroNetwork() {
		var section = document.getElementById("section1");
		if (!section) {
			setTimeout(initHeroNetwork, 100);
			return;
		}
		if (section.querySelector(".hero-network")) return;

		var themeUrl = window.innotechTheme ? window.innotechTheme.themeUrl : "";

		// Self-contained layout: these rules ship with the script, not the theme
		// stylesheet, so a stale cached/minified CSS file can't leave the canvas
		// unstyled (in flow, or painting over the hero text).
		if (!document.getElementById("hero-network-css")) {
			var style = document.createElement("style");
			style.id = "hero-network-css";
			style.textContent =
				"#section1>.hero-network{position:absolute;top:0;left:0;width:100%;height:100%;z-index:0;pointer-events:none;overflow:hidden}" +
				".hero-network__bg{position:absolute;top:0;right:0;bottom:0;left:0;background-size:cover;background-position:center;background-repeat:no-repeat;filter:brightness(1.25)}" +
				".hero-network__canvas{position:absolute;top:0;left:0;width:100%;height:100%;display:block}" +
				"#section1>*:not(.hero-network){position:relative;z-index:1}";
			document.head.appendChild(style);
		}

		// Layers: .hero-network (positioned fill)
		//           ├─ .hero-network__bg  — photo (brightness 1.25: <1 darker, >1 lighter)
		//           └─ canvas             — dots + links, unfiltered
		var wrap = document.createElement("div");
		wrap.className = "hero-network";
		wrap.setAttribute("aria-hidden", "true");

		var bg = document.createElement("div");
		bg.className = "hero-network__bg";
		bg.style.backgroundImage = 'url("' + themeUrl + '/_assets/background.webp")';

		var canvas = document.createElement("canvas");
		canvas.className = "hero-network__canvas";

		wrap.appendChild(bg);
		wrap.appendChild(canvas);
		section.style.position = "relative";
		section.insertBefore(wrap, section.firstChild);

		var ctx = canvas.getContext("2d");
		var reduceMotion =
			window.matchMedia &&
			window.matchMedia("(prefers-reduced-motion: reduce)").matches;

		var width = 0;
		var height = 0;
		var dots = [];
		var mouse = { x: 0, y: 0, active: false };
		var rafId = 0;
		var visible = true;
		var last = 0;

		function targetCount() {
			var n = Math.round(
				CONFIG.density * ((width * height) / (1920 * 1080)),
			);
			return Math.max(CONFIG.minDots, Math.min(CONFIG.maxDots, n));
		}

		function makeDot() {
			var angle = Math.random() * Math.PI * 2;
			return {
				x: Math.random() * width,
				y: Math.random() * height,
				vx: Math.cos(angle) * CONFIG.speed,
				vy: Math.sin(angle) * CONFIG.speed,
			};
		}

		function resize() {
			var rect = section.getBoundingClientRect();
			var w = Math.max(1, Math.round(rect.width));
			var h = Math.max(1, Math.round(rect.height));
			if (w === width && h === height) return;
			width = w;
			height = h;
			var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
			canvas.width = Math.round(width * dpr);
			canvas.height = Math.round(height * dpr);
			ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

			// Keep existing dots, add/remove to match the new area.
			var want = targetCount();
			while (dots.length < want) dots.push(makeDot());
			if (dots.length > want) dots.length = want;
			dots.forEach(function (d) {
				d.x = Math.min(d.x, width);
				d.y = Math.min(d.y, height);
			});
			draw();
		}

		function step(dt) {
			// dt is in 60fps frames so speed is the same on 60/120/144Hz screens.
			for (var i = 0; i < dots.length; i++) {
				var d = dots[i];
				d.x += d.vx * dt;
				d.y += d.vy * dt;
				if (d.x < 0) {
					d.x = 0;
					d.vx = Math.abs(d.vx);
				} else if (d.x > width) {
					d.x = width;
					d.vx = -Math.abs(d.vx);
				}
				if (d.y < 0) {
					d.y = 0;
					d.vy = Math.abs(d.vy);
				} else if (d.y > height) {
					d.y = height;
					d.vy = -Math.abs(d.vy);
				}
			}
		}

		function draw() {
			ctx.clearRect(0, 0, width, height);
			var maxD = CONFIG.linkDistance;
			var maxD2 = maxD * maxD;
			var i, j, a, b, dx, dy, d2, alpha;

			ctx.lineWidth = CONFIG.linkWidth;
			ctx.lineCap = "round";
			for (i = 0; i < dots.length; i++) {
				a = dots[i];
				for (j = i + 1; j < dots.length; j++) {
					b = dots[j];
					dx = a.x - b.x;
					if (dx > maxD || dx < -maxD) continue;
					dy = a.y - b.y;
					d2 = dx * dx + dy * dy;
					if (d2 >= maxD2) continue;
					alpha = CONFIG.linkOpacity * (1 - Math.sqrt(d2) / maxD);
					ctx.strokeStyle = "rgba(" + CONFIG.color + "," + alpha.toFixed(3) + ")";
					ctx.beginPath();
					ctx.moveTo(a.x, a.y);
					ctx.lineTo(b.x, b.y);
					ctx.stroke();
				}
			}

			// Cursor → nearby dots.
			if (mouse.active) {
				var mD = CONFIG.mouseDistance;
				for (i = 0; i < dots.length; i++) {
					a = dots[i];
					dx = a.x - mouse.x;
					dy = a.y - mouse.y;
					d2 = dx * dx + dy * dy;
					if (d2 >= mD * mD) continue;
					alpha = CONFIG.mouseOpacity * (1 - Math.sqrt(d2) / mD);
					ctx.strokeStyle = "rgba(" + CONFIG.color + "," + alpha.toFixed(3) + ")";
					ctx.beginPath();
					ctx.moveTo(a.x, a.y);
					ctx.lineTo(mouse.x, mouse.y);
					ctx.stroke();
				}
			}

			ctx.fillStyle = "rgba(" + CONFIG.color + "," + CONFIG.dotOpacity + ")";
			for (i = 0; i < dots.length; i++) {
				ctx.beginPath();
				ctx.arc(dots[i].x, dots[i].y, CONFIG.radius, 0, Math.PI * 2);
				ctx.fill();
			}
		}

		function frame(now) {
			rafId = 0;
			if (!visible || document.hidden) return;
			var dt = last ? Math.min((now - last) / 16.667, 3) : 1;
			last = now;
			step(dt);
			draw();
			rafId = requestAnimationFrame(frame);
		}

		function start() {
			if (reduceMotion || rafId || !visible || document.hidden) return;
			last = 0;
			rafId = requestAnimationFrame(frame);
		}

		function stop() {
			if (rafId) cancelAnimationFrame(rafId);
			rafId = 0;
		}

		// Cursor — the canvas ignores pointer events, so listen on the section.
		section.addEventListener("mousemove", function (e) {
			var rect = section.getBoundingClientRect();
			mouse.x = e.clientX - rect.left;
			mouse.y = e.clientY - rect.top;
			mouse.active = true;
			if (reduceMotion) draw();
		});
		section.addEventListener("mouseleave", function () {
			mouse.active = false;
			if (reduceMotion) draw();
		});

		// Pause while off-screen or in a background tab.
		if ("IntersectionObserver" in window) {
			new IntersectionObserver(function (entries) {
				visible = entries[0].isIntersecting;
				if (visible) start();
				else stop();
			}).observe(section);
		}
		document.addEventListener("visibilitychange", function () {
			if (document.hidden) stop();
			else start();
		});

		if ("ResizeObserver" in window) {
			new ResizeObserver(resize).observe(section);
		} else {
			window.addEventListener("resize", resize);
		}

		resize();
		start();
	}

	// Wait for DOM ready
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initHeroNetwork);
	} else {
		initHeroNetwork();
	}
})();
